import React from 'react';

const RouterInfoPanel = ({ router }) => (
  <div className="rounded-xl border border-slate-800 bg-slate-900/70 p-4">
    <h3 className="text-sm font-semibold uppercase tracking-[0.12em] text-cyan-200">Info Router</h3>
    {!router ? <p className="mt-2 text-sm text-slate-400">Belum ada router terpilih.</p> : (
        <div className="mt-2 grid gap-2 text-sm text-slate-300 md:grid-cols-2">
        <p>NAS Identifier: <span className="text-slate-100">{router.nasIdentifier || router.nas_identifier || '-'}</span></p>
        <p>IP Management: <span className="text-slate-100">{router.mgmtIp || router.mgmt_ip || '-'}</span></p>
        <p>Method: <span className="text-slate-100">{router.managementMethod || router.management_method || '-'}</span></p>
        <p>Status Discovery: <span className="text-slate-100">{router.lastDiscoveryStatus || router.last_discovery_status || '-'}</span></p>
        <p>Rekomendasi Uplink: <span className="text-slate-100">{router.recommendedPrimaryUplinkInterface || router.recommended_primary_uplink_interface || '-'}</span></p>
        <p>Interface Monitoring: <span className="text-slate-100">{(router.monitoredInterfaces || router.traffic_interface_whitelist || []).join(', ') || '-'}</span></p>
        </div>
    )}
  </div>
);

export default RouterInfoPanel;
